/* Tailwell theme (built on Plinth) – lightweight vanilla JS. Uses Shopify's native AJAX Cart API and Section Rendering API. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents);
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }
  function decodeEntities(str) { var t = document.createElement('textarea'); t.innerHTML = str; return t.value; }

  /* ---------- Header height (for drawers / sticky info column) ---------- */
  function setHeaderBottom() {
    var header = $('[data-header]');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(rect.bottom, 0) + 'px');
  }
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('scroll', setHeaderBottom, { passive: true });

  /* ---------- Menu drawer ---------- */
  function initMenuDrawer() {
    $$('[data-menu-drawer]').forEach(function (drawer) {
      drawer.addEventListener('toggle', function () {
        setHeaderBottom();
        document.body.style.overflow = drawer.open ? 'hidden' : '';
      });
    });
  }

  /* ---------- Search ---------- */
  function initSearch() {
    var modal = $('[data-search-modal]');
    if (!modal) return;
    var input = $('[data-search-input]', modal);
    var results = $('[data-predictive-results]', modal);
    var closeBtn = $('[data-search-close]', modal);
    var timer, controller;

    modal.addEventListener('toggle', function () {
      if (modal.open) { setTimeout(function () { input.focus(); }, 30); }
    });
    closeBtn.addEventListener('click', function () { modal.open = false; modal.querySelector('summary').focus(); });
    document.addEventListener('click', function (e) { if (modal.open && !modal.contains(e.target)) modal.open = false; });

    if (!theme.predictiveSearch || !results) return;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
      timer = setTimeout(function () { fetchSuggestions(q); }, 220);
    });

    function fetchSuggestions(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (data) { render(q, (data.resources && data.resources.results && data.resources.results.products) || []); })
        .catch(function () {});
    }

    function render(q, products) {
      var html = '';
      if (!products.length) {
        html = '<p class="predictive__heading">' + escapeHtml(theme.strings.searchNoResults) + '</p>';
      } else {
        html += '<p class="predictive__heading">' + escapeHtml(theme.strings.products) + '</p><ul class="predictive__list" role="list">';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = formatMoney(Math.round(parseFloat(p.price) * 100));
          html += '<li><a class="predictive__item" href="' + p.url + '">' +
            (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56" loading="lazy">' : '') +
            '<span><span class="predictive__title">' + escapeHtml(p.title) + '</span><span class="predictive__price">' + escapeHtml(price) + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      html += '<a class="link-underline predictive__all" href="' + modal.querySelector('form').getAttribute('action') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + escapeHtml(theme.strings.searchViewAll.replace('[terms]', q)) + '</a>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart ---------- */
  var Cart = {
    drawer: function () { return $('[data-cart-drawer]'); },
    open: function () {
      var d = Cart.drawer();
      if (!d) { window.location.href = theme.routes.cart; return; }
      if (!d.open) { d.showModal(); document.body.style.overflow = 'hidden'; }
    },
    close: function () {
      var d = Cart.drawer();
      if (d && d.open) d.close();
    },
    renderSections: function (sections) {
      if (!sections || !sections['cart-drawer']) return;
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc);
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) {
        current.replaceWith(fresh);
        Cart.updateCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
      }
    },
    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },
    change: function (line, quantity) {
      var d = Cart.drawer();
      if (d) d.classList.add('is-busy');
      return fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.cartError);
          Cart.renderSections(res.data.sections);
          return Offers.sync().then(function (changed) {
            if (!changed && window.location.pathname === theme.routes.cart) window.location.reload();
          });
        })
        .catch(function (err) {
          var lineEl = $('[data-cart-line="' + line + '"] [data-line-error]');
          if (lineEl) { lineEl.textContent = decodeEntities(err.message); lineEl.hidden = false; }
        })
        .finally(function () { var dd = Cart.drawer(); if (dd) dd.classList.remove('is-busy'); });
    }
  };


  /* ---------- Bundle offers: keep the right tier code on the cart ---------- */
  var Offers = {
    cfg: function () { return theme.offers || { enabled: false, tiers: [] }; },
    tiers: function () {
      return (Offers.cfg().tiers || []).filter(function (t) { return t.qty > 0 && t.percent > 0; })
        .sort(function (a, b) { return b.qty - a.qty; });
    },
    percentFor: function (count) {
      if (!Offers.cfg().enabled) return 0;
      var t = Offers.tiers().find(function (x) { return count >= x.qty; });
      return t ? t.percent : 0;
    },
    codeFor: function (count) {
      var t = Offers.tiers().find(function (x) { return count >= x.qty && x.code; });
      return t ? t.code : '';
    },
    ourCodes: function () { return Offers.tiers().map(function (t) { return (t.code || '').toUpperCase(); }).filter(Boolean); },
    busy: false,
    sync: function () {
      var cfg = Offers.cfg();
      if (!cfg.enabled || !cfg.autoApply || !Offers.ourCodes().length || Offers.busy) return Promise.resolve(false);
      Offers.busy = true;
      return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ours = Offers.ourCodes();
          var applied = (cart.discount_codes || []).map(function (d) { return String(d.code || ''); });
          var others = applied.filter(function (c) { return ours.indexOf(c.toUpperCase()) === -1; });
          var mine = applied.filter(function (c) { return ours.indexOf(c.toUpperCase()) > -1; }).map(function (c) { return c.toUpperCase(); });
          var target = Offers.codeFor(cart.item_count);
          var wanted = target ? [target] : [];
          if (mine.length === wanted.length && mine.join() === wanted.join()) return false;
          return fetch(theme.routes.cart + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: others.concat(wanted).join(','), sections: ['cart-drawer'], sections_url: window.location.pathname })
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              /* Fallback for stores where the Ajax cart ignores the discount field: set it for checkout. */
              if (target && !(data.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === target; })) {
                fetch(theme.routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(target), { credentials: 'same-origin' });
              }
              if (data.sections) Cart.renderSections(data.sections);
              if (window.location.pathname === theme.routes.cart) window.location.reload();
              return true;
            });
        })
        .catch(function () { return false; })
        .finally(function () { Offers.busy = false; });
    }
  };

  /* ---------- Bundle forms (home bundles + "Complete the kit" on product pages) ---------- */
  function initBundles(root) {
    $$('[data-bundle-form]', root).forEach(function (form) {
      if (form.getAttribute('data-bundle-ready')) return;
      form.setAttribute('data-bundle-ready', 'true');
      form.addEventListener('change', function () { Bundle.recalc(form); });
      form.addEventListener('submit', function (e) { e.preventDefault(); Bundle.submit(form); });
      Bundle.recalc(form);
    });
  }
  var Bundle = {
    rows: function (form) { return $$('[data-bundle-row]', form); },
    priceOf: function (row) {
      var v = $('[data-bundle-variant]', row);
      if (!v) return 0;
      var src = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      return parseInt(src.getAttribute('data-price'), 10) || 0;
    },
    selected: function (form) {
      return Bundle.rows(form).filter(function (row) { var c = $('[data-bundle-check]', row); return c && c.checked; });
    },
    recalc: function (form) {
      var total = 0, count = 0;
      Bundle.rows(form).forEach(function (row) {
        var p = Bundle.priceOf(row);
        var priceEl = $('[data-bundle-row-price]', row);
        if (priceEl) priceEl.textContent = formatMoney(p);
        var c = $('[data-bundle-check]', row);
        row.classList.toggle('is-off', !(c && c.checked));
      });
      Bundle.selected(form).forEach(function (row) { total += Bundle.priceOf(row); count += 1; });
      var pct = Offers.percentFor(count);
      var final = Math.round(total * (100 - pct) / 100);
      var saving = total - final;
      var finalEl = $('[data-bundle-final]', form);
      var cmpEl = $('[data-bundle-compare]', form);
      var savEl = $('[data-bundle-saving]', form);
      var savAmt = $('[data-bundle-saving-amount]', form);
      if (finalEl) finalEl.textContent = formatMoney(final);
      if (cmpEl) { cmpEl.textContent = formatMoney(total); cmpEl.hidden = saving <= 0; }
      if (savEl) savEl.hidden = saving <= 0;
      if (savAmt) savAmt.textContent = formatMoney(saving);
      var btn = $('[data-bundle-submit]', form);
      if (btn) btn.disabled = count === 0;
    },
    submit: function (form) {
      var items = Bundle.selected(form).map(function (row) {
        var v = $('[data-bundle-variant]', row);
        return { id: parseInt(v.value, 10), quantity: 1 };
      }).filter(function (i) { return i.id; });
      var errorEl = $('[data-form-error]', form);
      var btn = $('[data-bundle-submit]', form);
      if (errorEl) errorEl.hidden = true;
      if (!items.length) { if (errorEl) { errorEl.textContent = theme.strings.selectItems; errorEl.hidden = false; } return; }
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
      var useDrawer = theme.cartType === 'drawer' && Cart.drawer();
      fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: useDrawer ? ['cart-drawer'] : [], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.cartError);
          if (!useDrawer) { return Offers.sync().then(function () { window.location.href = theme.routes.cart; }); }
          Cart.renderSections(res.data.sections);
          Cart.open();
          return Offers.sync();
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = decodeEntities(err.message); errorEl.hidden = false; }
        })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
    }
  };

  function initCart() {
    var toggle = $('[data-cart-toggle]');
    if (toggle && theme.cartType === 'drawer') {
      toggle.addEventListener('click', function (e) {
        if (window.location.pathname === theme.routes.cart) return;
        e.preventDefault();
        Cart.open();
      });
    }

    document.addEventListener('click', function (e) {
      var d = Cart.drawer();
      if (!d) return;
      if (e.target === d) { Cart.close(); return; }
      if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn && d.contains(qtyBtn)) {
        Cart.change(parseInt(qtyBtn.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-cart-qty'), 10));
      }
    });

    var drawer = Cart.drawer();
    if (drawer) drawer.addEventListener('close', function () { document.body.style.overflow = ''; });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-note]')) return;
      fetch(theme.routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    });

    /* Add to cart (product page, cart upsells) */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form || theme.cartType !== 'drawer' || !Cart.drawer()) return;
      e.preventDefault();
      var formId = form.id;
      var buttons = $$('button[type="submit"]', form).concat(formId ? $$('button[form="' + formId + '"]') : []);
      var errorEl = $('[data-form-error]', form);
      buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-disabled', 'true'); });
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      fetch(theme.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.cartError);
          Cart.renderSections(res.data.sections);
          Cart.open();
          Offers.sync();
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = decodeEntities(err.message); errorEl.hidden = false; }
          else { window.alert(decodeEntities(err.message)); }
        })
        .finally(function () {
          buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-disabled'); });
        });
    });

    /* Cart page – submit updates automatically when a quantity changes */
    var cartForm = $('[data-cart-page-form]');
    if (cartForm) {
      var t;
      cartForm.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cart-page-qty]')) return;
        clearTimeout(t);
        t = setTimeout(function () {
          var u = document.createElement('input');
          u.type = 'hidden'; u.name = 'update'; u.value = '1';
          cartForm.appendChild(u);
          cartForm.submit();
        }, 400);
      });
    }
  }

  /* ---------- Quantity steppers (product page, cart page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
    if (next === parseInt(input.value, 10)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var formId = section.getAttribute('data-form-id');
    var lowStock = parseInt(section.getAttribute('data-low-stock'), 10) || 0;
    var picker = $('[data-variant-picker]', section);
    var track = $('[data-gallery-track]', section);
    var thumbs = $$('[data-thumb]', section);

    /* Gallery */
    function showMedia(mediaId, smooth) {
      if (!track || !mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', track);
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActiveThumb(mediaId);
    }
    function setActiveThumb(mediaId) {
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-thumb') === String(mediaId);
        t.classList.toggle('is-active', active);
        if (active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb'), true); }); });
    if (track && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio > 0.6) setActiveThumb(en.target.getAttribute('data-media-id')); });
      }, { root: track, threshold: [0.6] });
      $$('[data-media-id]', track).forEach(function (s) { io.observe(s); });
    }

    /* Zoom */
    var zoom = $('[data-zoom-dialog]', section);
    if (zoom && zoom.showModal) {
      var zoomImg = $('[data-zoom-img]', zoom);
      $$('[data-zoom-src]', section).forEach(function (btn) {
        btn.addEventListener('click', function () {
          zoomImg.src = btn.getAttribute('data-zoom-src');
          zoomImg.alt = btn.getAttribute('data-zoom-alt') || '';
          zoom.showModal();
        });
      });
      zoom.addEventListener('click', function (e) { if (e.target === zoom || e.target === zoomImg || e.target.closest('[data-zoom-close]')) zoom.close(); });
    }

    /* Variants */
    function selectedOptions() {
      if (!picker) return null;
      return $$('fieldset', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      $$('fieldset', picker).forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[index] = input.value;
          var match = findVariant(test);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function updateUI(variant) {
      var idInput = document.querySelector('#' + formId + ' [data-variant-id]');
      var addButtons = $$('[data-add-button], [data-sticky-button]', section);
      if (!variant) {
        addButtons.forEach(function (b) { b.disabled = true; var l = $('[data-add-label]', b); if (l) l.textContent = theme.strings.unavailable; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      addButtons.forEach(function (b) {
        b.disabled = !variant.available;
        var l = $('[data-add-label]', b);
        if (l) l.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      });
      $$('[data-price]', section).forEach(function (priceEl) {
        var cur = $('[data-price-current]', priceEl);
        var cmp = $('[data-price-compare]', priceEl);
        if (cur) cur.textContent = formatMoney(variant.price);
        var onSale = variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', onSale);
        if (cmp) {
          cmp.hidden = !onSale;
          var s = $('s', cmp); if (s) s.textContent = formatMoney(variant.compare_at_price);
        }
      });
      var stock = $('[data-stock]', section);
      if (stock) {
        var text = $('[data-stock-text]', stock);
        stock.classList.remove('stock--in', 'stock--low', 'stock--out');
        if (!variant.available) { stock.classList.add('stock--out'); text.textContent = theme.strings.soldOut; }
        else if (variant.stock !== null && variant.stock > 0 && variant.stock <= lowStock) { stock.classList.add('stock--low'); text.textContent = theme.strings.lowStock.replace('[count]', variant.stock); }
        else { stock.classList.add('stock--in'); text.textContent = theme.strings.inStock; }
      }
      $$('[data-bundle-main-variant]', section).forEach(function (input) {
        input.value = variant.id;
        input.setAttribute('data-price', variant.price);
        var form = input.closest('[data-bundle-form]');
        var t = form && $('[data-bundle-main-title]', form);
        if (t) t.textContent = variant.options.join(' / ');
        if (form) Bundle.recalc(form);
      });
      if (variant.media_id) showMedia(variant.media_id, true);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (picker) {
      picker.addEventListener('change', function (e) {
        var fs = e.target.closest('fieldset');
        var label = fs && $('[data-option-label]', fs);
        if (label) label.textContent = e.target.value;
        var opts = selectedOptions();
        markAvailability(opts);
        updateUI(findVariant(opts));
      });
      markAvailability(selectedOptions());
    }
    var initialId = parseInt(new URL(window.location.href).searchParams.get('variant'), 10);
    var initial = data.variants.find(function (v) { return v.id === initialId; });
    if (initial && initial.media_id) showMedia(initial.media_id, false);

    /* Sticky add to cart (mobile) */
    var sticky = $('[data-sticky-atc]', section);
    var mainBtn = $('[data-add-button]', section);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var pastButton = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', pastButton);
      }).observe(mainBtn);
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.getAttribute('data-loaded')) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        el.setAttribute('data-loaded', 'true');
      }).catch(function () {});
    });
  }

  /* ---------- Collection / search filters ---------- */
  function initFacets(root) {
    $$('[data-facets-form]', root).forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; /* price inputs submit via Apply */
        form.submit();
      });
      form.addEventListener('submit', function () {
        $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    });
    document.addEventListener('click', function (e) {
      $$('[data-facet][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }

  /* ---------- Accounts ---------- */
  function initAccounts() {
    $$('form[data-confirm]').forEach(function (f) {
      f.addEventListener('submit', function (e) { if (!window.confirm(f.getAttribute('data-confirm'))) e.preventDefault(); });
    });
    $$('select[data-default]').forEach(function (s) {
      var v = s.getAttribute('data-default');
      if (v) s.value = v;
    });
  }

  /* ---------- Escape key closes open overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-search-modal][open], [data-menu-drawer][open], [data-facet][open]').forEach(function (d) {
      d.open = false;
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });

  function init() {
    setHeaderBottom();
    initMenuDrawer();
    initSearch();
    initCart();
    $$('[data-product-section]').forEach(initProduct);
    initBundles(document);
    Offers.sync();
    initRecommendations(document);
    initFacets(document);
    initAccounts();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    initBundles(e.target);
    initRecommendations(e.target);
    setHeaderBottom();
  });

  window.ThemeCart = Cart;
  window.ThemeOffers = Offers;
})();
